/* RS navigation: sticky state, hover to open the mega menu (delay, no animation when moving between
   items), cart count in the sticky bar. */
if (!customElements.get('rs-navigation')) {
  class RsNavigation extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.shopify-section');
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.hoverCapable = window.matchMedia('(hover: hover) and (min-width: 990px)');
      this.frame = 0;

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateStuck();
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.desktop.addEventListener('change', this.onScroll);
      this.updateStuck();

      if (this.hasAttribute('data-hover')) this.setUpHover();
      this.setUpCart();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.desktop.removeEventListener('change', this.onScroll);
      if (this.unsubscribeCart) this.unsubscribeCart();
    }

    updateStuck() {
      const stuck =
        this.desktop.matches &&
        window.scrollY > 0 &&
        this.wrapper &&
        this.wrapper.getBoundingClientRect().top <= 0.5;
      this.classList.toggle('is-stuck', Boolean(stuck));
    }

    // Panels open on hover after the "Wait before opening" setting (data-open-delay). Moving from an
    // open panel to the next item opens it at once and without the opening animation
    // (rs-navigation--switching), so going along the bar does not feel slow.
    setUpHover() {
      const delay = Number(this.dataset.openDelay) || 0;
      const speed = Number(this.dataset.animSpeed) || 300;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let lastClosed = 0;

      // "Fade out when closing" (data-close-fade): the panel stays open with rs-nav-closing until the
      // fade (rs-navigation.css) has run. stopClosing() keeps it open (mouse back on the item) or,
      // with shut, closes it at once (another panel opens).
      const stopClosing = (details, shut) => {
        clearTimeout(details.rsCloseTimer);
        details.classList.remove('rs-nav-closing');
        if (shut) details.removeAttribute('open');
      };
      const close = (details) => {
        if (!this.hasAttribute('data-close-fade') || reduceMotion.matches) {
          details.removeAttribute('open');
          return;
        }
        details.classList.add('rs-nav-closing');
        details.rsCloseTimer = setTimeout(() => stopClosing(details, true), speed * 0.6 + 50);
      };

      this.querySelectorAll('header-menu').forEach((menu) => {
        const details = menu.querySelector('details');
        const summary = details && details.querySelector('summary');
        if (!details || !summary) return;

        let timer;
        let openTimer;

        const open = () => {
          const others = Array.from(this.querySelectorAll('details[open]')).filter((other) => other !== details);
          const switching = others.length > 0 || Date.now() - lastClosed < 300;
          this.classList.toggle('rs-navigation--switching', switching);
          others.forEach((other) => stopClosing(other, true));
          details.setAttribute('open', '');
        };

        menu.addEventListener('mouseenter', () => {
          if (!this.hoverCapable.matches) return;
          clearTimeout(timer);
          clearTimeout(openTimer);
          if (details.hasAttribute('open')) {
            stopClosing(details, false);
            return;
          }
          const panelOpen = this.querySelector('details[open]');
          if (delay && !panelOpen) openTimer = setTimeout(open, delay);
          else open();
        });

        menu.addEventListener('mouseleave', () => {
          if (!this.hoverCapable.matches) return;
          clearTimeout(openTimer);
          timer = setTimeout(() => {
            if (!details.hasAttribute('open') || details.classList.contains('rs-nav-closing')) return;
            lastClosed = Date.now();
            close(details);
          }, 150);
        });

        summary.addEventListener('click', (event) => {
          // event.detail is 0 for keyboard-triggered clicks, which keep opening the panel
          const url = summary.dataset.url;
          if (this.hoverCapable.matches && event.detail > 0 && url) {
            event.preventDefault();
            window.location.href = url;
          }
        });
      });
    }

    setUpCart() {
      const count = this.querySelector('.rs-navigation__count');
      if (!count) return;

      const update = (total) => {
        count.textContent = total;
        count.hidden = !total;
      };

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
            .then((response) => response.json())
            .then((cart) => update(cart.item_count))
            .catch(() => {});
        });
      }
    }
  }

  customElements.define('rs-navigation', RsNavigation);
}
